import { connect } from 'react-redux';

const mapStateToProps = (state) => {
    const { area: { area } } = state;
    return {
        area
    }
};

export default WrappedComponent => connect(
    mapStateToProps,
    {},
    null
)(WrappedComponent);




// WEBPACK FOOTER //
// ./src/modules/common/components/areaselect/withArea.js